
import { useState, useRef, useEffect } from "react";
import { SubscriptionStatus } from "@/services/subscription";

export const useSubscriptionStatus = (
  subscriptionStatus: SubscriptionStatus | null,
  user: any
) => {
  const [lastCheckedStatus, setLastCheckedStatus] = useState<SubscriptionStatus | null>(null);
  const isCheckingSubscriptionRef = useRef(false);
  const hasCheckedSubscriptionRef = useRef(false);
  const transformationCountRef = useRef(0);
  const statusUpdateTimeRef = useRef(0);

  // Update last checked status when subscription status changes, but avoid frequent updates
  useEffect(() => {
    if (subscriptionStatus && (!lastCheckedStatus || 
        JSON.stringify(subscriptionStatus) !== JSON.stringify(lastCheckedStatus))) {
      // Only update if the data is actually different or if sufficient time has passed
      const now = Date.now();
      if (!statusUpdateTimeRef.current || now - statusUpdateTimeRef.current > 1000) {
        setLastCheckedStatus(subscriptionStatus);
        statusUpdateTimeRef.current = now;
      }
    }
  }, [subscriptionStatus, lastCheckedStatus]);

  // Helper to check subscription status
  const isSubscriptionActive = (status: SubscriptionStatus | null): boolean => {
    if (!status) return false;
    return status.isActive;
  };

  // Helper to check if user has free transforms left
  const hasFreeTransforms = (status: SubscriptionStatus | null): boolean => {
    if (!status) return false;
    return !!(status.remainingFreeTransforms && status.remainingFreeTransforms > 0);
  };

  // Helper to check if local storage confirms active subscription
  const isLocallyConfirmedActive = (): boolean => {
    return localStorage.getItem('subscription_confirmed_active') === 'true';
  };

  return {
    lastCheckedStatus,
    setLastCheckedStatus,
    isCheckingSubscriptionRef,
    hasCheckedSubscriptionRef, 
    transformationCountRef,
    isSubscriptionActive,
    hasFreeTransforms,
    isLocallyConfirmedActive
  };
};
